import { render, staticRenderFns } from "./TemplateSection.vue?vue&type=template&id=3d31fc6f&scoped=true&"
import script from "./TemplateSection.vue?vue&type=script&lang=ts&"
export * from "./TemplateSection.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSection.vue?vue&type=style&index=0&id=3d31fc6f&scoped=true&lang=css&"
import style1 from "./TemplateSection.vue?vue&type=style&index=1&id=3d31fc6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d31fc6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
